import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

import { ValidationResult } from '../../../core/validators'

@Component({
  selector: 'app-form-validation',
  templateUrl: './form-validation.component.html',
  styleUrls: ['./form-validation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormValidationComponent implements OnChanges {
  @Input() result: ValidationResult
  @Input() title: string

  constructor(
    private element: ElementRef,
    private translate: TranslateService
  ) {}

  ngOnChanges() {
    if(this.hasErrors)
      this.scrollToMe()
  }

  get hasErrors(): boolean {
    return this.result && this.result.hasErrors
  }

  get errorMessages(): { name: string, translationCode: string }[] {
    return Object.keys(this.result.errors).reduce(
      (msgs, key) => [...msgs, ...this.result.errors[key]], [])
  }

  scrollToMe() {
    let top = this.element.nativeElement.scrollTop
    if(window)
      window.scrollTo(0, top)
  }
}
